import React, { PureComponent } from 'react';
import Select from 'react-select';
import { Input, Tooltip } from '..';
import { Radio } from 'material-ui';
import intl from 'react-intl-universal';

let qualityOptions = [
  { value: '', label: 'No Change' },
  { value: '100', label: 'Best Image Quality' },
  { value: '75', label: 'Good Image Quality' },
  { value: '50', label: 'Average Image Quality' }
];

const fileSizeOptions = [
  { value: 'kb', label: 'KB' },
  { value: 'mb', label: 'MB' }
];

export default class ImageCompressor extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      resizeType: 'predefined'
    };
  }

  onChangeOptions = (key) => (val, { prefix, suffix }) => {
    if(key === 'fileSize') {
      this.props.onOptionChange({
        quality: ''
      })
      
    }
    this.props.onOptionChange({
      [key]: val,
      [`${key}Prefix`]: prefix,
      [`${key}Suffix`]: suffix
    })
  };

  onChangeSelect = (key) => ({ value }) => {
    if(key === 'quality') {
      this.props.onOptionChange({
        fileSize: ''
      })
      
    }
    this.props.onOptionChange({
      [key]: value
    })
  };

  getProps() {
    const result = {};

    if (qualityOptions.map(({ value }) => value).indexOf(this.props.quality) < 0) {
      result.quality = qualityOptions[0].value;
    }

    if (fileSizeOptions.map(({ value }) => value).indexOf(this.props.fileSizeSuffix) < 0) {
      result.fileSizeSuffix = fileSizeOptions[0].value;
    }

    return { ...this.props, ...result };
  }
  onChangeType = ({ currentTarget }) => this.setState({ resizeType: currentTarget.value });

  renderMaxFileSize() {
    const {resizeType} = this.state;
    const { fileSize, fileSizeSuffix, format } = this.getProps();
    let input = '';

    if(this.state.resizeType==='custom') {
      input = (
        <div className='section'>
            <Input
              onChange={this.onChangeOptions('fileSize')}
              border={true}
              type='number'
              min='0'
              step='1'
              value={fileSize}
              suffixValue={fileSizeSuffix}
              suffix={fileSizeOptions}
            >
              {intl.get('Max File Size')}
              <span className='deemphasize'>{intl.get('(Optional)')}</span>

              <Tooltip hint="We will attempt to make your image smaller than this size. This feature does not work for PNG files" />
            </Input>
          </div>
      );
    }
    let disabled = false;
    if (format === 'png') {
      disabled = true;
      if(resizeType !== 'predefined') {
        this.setState({resizeType: 'predefined'});
      }
    }
    return (
      <div>
        <label>
          <Radio name="resize-type" value="custom" 
            checked={resizeType === 'custom'} 
            disabled={disabled}
            onChange={this.onChangeType} />&nbsp;
          {intl.get('Or Choose a Max File Size')}
        </label>
        {input}
      </div>
    );
  }
  render() {
    const {quality} = this.getProps();
    const {resizeType} = this.state;

    qualityOptions = [
      { value: '', label: intl.get('No Change') },
      { value: '100', label: intl.get('Best Image Quality') },
      { value: '75', label: intl.get('Good Image Quality') },
      { value: '50', label: intl.get('Average Image Quality') }
    ];
    let select = '';
    if(this.state.resizeType !=='custom') {
      select = (
        <div className='section'>
          <Select
            name='quality'
            value={quality}
            options={qualityOptions}
            onChange={this.onChangeSelect('quality')}
            clearable={false}
            />
        </div>
      );
    }
    return (
      <div>
        <div>
          <div className="twoSections">
            <div className='section'>
              <label>
                <Radio name="resize-type" value="predefined"
                    checked={resizeType === 'predefined'} 
                    onChange={this.onChangeType} />&nbsp;
                {intl.get('Choose optimization level')}
              </label>
              {select}
              {this.renderMaxFileSize()}
            </div>
            <div className='section'>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageCompressor/index.jsx